module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/big/2-fee6bfa3cfc09e1b4125110445425aae.webp";